var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"box",attrs:{"id":"networks"}},[_c('network-manager',{attrs:{"contact-id":_vm.contactId,"context":"profile","networks":_vm.availableNetworks,"contact-networks":_vm.contactNetworks}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }